import type { NodeViewRenderers } from 'ricos-types';
import { Node_Type } from 'ricos-types';

import Image from './viewer-image';

export const nodeViewRenderers: NodeViewRenderers = {
  [Node_Type.IMAGE]: Image,
};
